<template>
    <div :class="[
        'input-number',
        { 'is-error': isError }
    ]">
        <label v-text="label" />
        <input 
            v-model="value"
            :maxlength="maxlength"
            @input="onInput" 
            @keyup="isError = false"
        />
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        maxlength: {
            type: Number,
            required: false,
            default: 100
        }
    },

    data() {
        return {
            value: null
        }
    },

    methods: {
        onInput() {
            this.$emit('input', this.value)
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired(),
                this.validateAgainstMinLength(10),
                this.validateAgainstNumberRegex()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-number {
    @include input();
}
</style>
